export const NAVIGATION_ORAGE = "#E8983C";
export const NAVIGATION_PURPLE = "#7E3CE8";
export const NAVIGATION_BLUE = "#3C7BE8";
export const NAVIGATION_PINK = "#E83C89";